// The actor recorded on an audit/history event, exactly as stored: a resolved user name; "Actor not recorded" when no actor id was stored;
// "System" only when the event's own data explicitly marks system origin; "Actor unavailable" (with the stored id) when the id no longer resolves.
// Never the current assignee, nothing inferred.
export function actorLabel(a) {
  if (a?.actor_kind === "USER" && a.actor_name) return a.actor_name;
  if (a?.actor_kind === "UNAVAILABLE") return `Actor unavailable (id ${String(a.actor_user_id).slice(0, 8)}…)`;
  if (a?.actor_kind === "SYSTEM") return "System";
  return "Actor not recorded";
}

export function ActorStamp({ event, testId }) {
  const kind = event?.actor_kind || "NOT_RECORDED";
  const tone = kind === "USER" ? "text-jigsaw-navy" : "italic text-jigsaw-muted";
  const title = event?.actor_user_id ? `User id ${event.actor_user_id}` : kind === "SYSTEM" ? "System origin recorded on this event" : "No actor id was recorded on this event";
  return (
    <span data-testid={testId} data-actor-kind={kind} title={title} className={tone}>
      {actorLabel(event)}
    </span>
  );
}
